/**
 * 注册着陆页表单交互逻辑（Phase 1 从 main-register-landing.liquid 抽出）
 *
 * 职责：邮箱校验、Continue 跳转、layoutChange 时 reload
 * 由 sections/main-register-landing.liquid 通过 root-layout page_js 在 DOM 之后加载
 */





  document.addEventListener('DOMContentLoaded', function () {

    // 根据当前设备类型选择正确的布局
    const isMobile = window.innerWidth <= 734;
    const targetLayout = isMobile ? '.root-mobile-layout' : '.root-desktop-layout';

    // On mobile, open legal links in same tab to preserve return flow
    if (isMobile) {
      const legalLinks = document.querySelectorAll('.register-landing-page__footer-text a, .register-landing-page__agreement-dialog a');
      legalLinks.forEach(link => {
        link.setAttribute('target', '_self');
        link.removeAttribute('rel');
      });
    }

    // 在指定的布局中查找元素
    const layout = document.querySelector(targetLayout);
    if (!layout) {
      return;
    }

    const form = layout.querySelector('#registerForm');
    const emailInput = layout.querySelector('.register-landing-page__email-input input');
    const continueButton = layout.querySelector('.register-landing-page__continue-button');
    const agreementCheckbox = layout.querySelector('.register-landing-page__footer-checkbox');
    const agreementDialog = layout.querySelector('#registerAgreementDialog') || document.getElementById('registerAgreementDialog');
    const agreementConfirmButton = layout.querySelector('#registerAgreementConfirm') || document.getElementById('registerAgreementConfirm');
    const agreementCancelButton = layout.querySelector('#registerAgreementCancel') || document.getElementById('registerAgreementCancel');
    let previousActiveElement = null;

    // 使用输入框组件的验证方法
    function validateInputUsingComponent() {
      if (!emailInput) return { isValid: false };

      // 移除首尾空格和所有中间空格，确保邮箱格式正确
      const value = emailInput.value.trim().replace(/\s/g, '');
      const hasError = emailInput.classList.contains('component-text-input__field--error');

      return {
        isValid: value && !hasError,
        value: value
      };
    }


    // 显示错误信息
    function showError(message) {
      window.showTextInputError(message, 'input[data-intended-type="email"]');
    }

    // 隐藏错误信息
    function hideError() {
      window.hideTextInputError('input[data-intended-type="email"]');
    }

    async function submitRegistration(validation) {
      if (!validation || !validation.isValid) {
        return;
      }
      
      hideError();

      try {
        const isValid = await window.userProfileAPI.checkEmailValidity(validation.value, 2);
        const accountResult = window.resolveAccountCheck
          ? window.resolveAccountCheck('register', isValid)
          : { allow: true, blocked: false, message: '' };

        if (!isValid || isValid.code !== 200) {
          setTimeout(() => {
            const serverMessage = (
              isValid &&
              (isValid.message ||
                isValid.msg ||
                isValid.data?.message ||
                isValid.data?.msg)
            ) || 'Please try again.';
            showError(serverMessage, 'backend');
          }, 150);

          return;
        }

        if (accountResult.blocked) {
          showError(accountResult.message, 'backend');
          return;
        }
        
        const data = isValid.data;
        if (typeof data === 'string' && data.startsWith('https')) {
          sessionStorage.setItem('activateEmail', validation.value);
          sessionStorage.setItem('activeUrl', data);
          
          setTimeout(() => {
            window.location.href = window.withSitePrefix ? window.withSitePrefix(data) : data;
          }, 150);
          return;
        }

        sessionStorage.setItem('verificationType', 'register');
        sessionStorage.setItem('verifyEmail', validation.value);

        setTimeout(() => {
          window.location.href = window.withSitePrefix ? window.withSitePrefix('/pages/verify-code') : '/pages/verify-code';
        }, 150);
      } catch (error) {
        const errorMessage =
          error?.message ||
          error?.msg ||
          error?.data?.message ||
          error?.data?.msg ||
          'Please try again.';

        setTimeout(() => {
          showError(errorMessage, 'backend');
        }, 150);
      }
    }

    function showAgreementDialog() {
      if (!agreementDialog) {
        return;
      }

      previousActiveElement = document.activeElement;
      agreementDialog.classList.add('register-landing-page__agreement-dialog--show');
      agreementDialog.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');

      if (agreementConfirmButton) {
        agreementConfirmButton.focus();
      }
    }

    function hideAgreementDialog() {
      if (!agreementDialog) {
        return;
      }

      agreementDialog.classList.remove('register-landing-page__agreement-dialog--show');
      agreementDialog.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');

      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
      }
    }

    async function handleRegistrationAttempt(options = {}) {
      const skipAgreementCheck = options.skipAgreementCheck === true;

      if (emailInput && emailInput.classList.contains('component-text-input__field--error')) {
        return;
      }

      const validation = validateInputUsingComponent();

      if (!validation.isValid) {
        return;
      }

      if (!skipAgreementCheck && agreementCheckbox && !agreementCheckbox.checked) {
        showAgreementDialog();
        return;
      }

      await submitRegistration(validation);
    }

    // 输入框事件监听
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        // 清除错误信息（用户输入时）
        hideError();

        // 检查输入框状态来控制按钮
        updateButtonBasedOnInputValidation();
      });

      // 聚焦时清除错误
      emailInput.addEventListener('focus', function () {
        hideError();
        if (!this.value.trim()) {
          this.classList.add('component-text-input__field--focused');
        }
      });

      // 失焦时检查按钮状态
      emailInput.addEventListener('blur', function () {
        // 检查输入框状态来控制按钮
        updateButtonBasedOnInputValidation();
      });
    }

    if (agreementCheckbox) {
      agreementCheckbox.addEventListener('change', function () {
        if (this.checked) {
          hideAgreementDialog();
        }
      });
    }

    if (agreementCancelButton) {
      agreementCancelButton.addEventListener('click', function () {
        hideAgreementDialog();
      });
    }

    if (agreementConfirmButton) {
      agreementConfirmButton.addEventListener('click', async function () {
        if (agreementCheckbox) {
          agreementCheckbox.checked = true;
        }
        hideAgreementDialog();
        await handleRegistrationAttempt({ skipAgreementCheck: true });
      });
    }

    if (agreementDialog) {
      agreementDialog.addEventListener('click', function (event) {
        const closeTarget = event.target.closest('[data-dialog-close="true"]');
        if (closeTarget) {
          hideAgreementDialog();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && agreementDialog && agreementDialog.classList.contains('register-landing-page__agreement-dialog--show')) {
        hideAgreementDialog();
      }
    });

    // 根据输入框状态更新按钮 - 只要有值就可以点击
    function updateButtonBasedOnInputValidation() {
      if (!emailInput || !continueButton) return;

      const value = emailInput.value.trim();

      // 只要有值就可以启用按钮
      if (value) {
        continueButton.classList.remove('component-cta-button--disabled');
        continueButton.classList.add('component-cta-button--enabled');
        continueButton.disabled = false;
      } else {
        // 如果为空，禁用按钮
        continueButton.classList.remove('component-cta-button--enabled');
        continueButton.classList.add('component-cta-button--disabled');
        continueButton.disabled = true;
      }
    }

    // 初始化按钮状态 - 默认禁用
    if (continueButton) {
      continueButton.classList.remove('component-cta-button--enabled');
      continueButton.classList.add('component-cta-button--disabled');
      continueButton.disabled = true;
    }

    // 表单提交事件
    if (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        await handleRegistrationAttempt();
      });
    }

    // Login 按钮点击事件
    const loginButton = layout.querySelector('.register-landing-page__login-button');
    if (loginButton) {
      loginButton.addEventListener('click', function () {
        const loginUrl = window.withSitePrefix ? window.withSitePrefix('/pages/login') : '/pages/login';
        window.location.href = loginUrl;
      });
    }

    // // Google 登录按钮事件
    // if (googleLoginBtn) {
    //   googleLoginBtn.addEventListener('click', handleGoogleLogin);
    // }

    // // Apple 登录按钮事件
    // if (appleLoginBtn) {
    //   appleLoginBtn.addEventListener('click', handleAppleLogin);
    // }

    // // 第三方登录初始化
    // initializeThirdPartyLogin();

    // 布局变化监听器 - 确保在DOM加载后绑定，更安全
    window.addEventListener('layoutChange', function () {
      // 重新初始化页面
      location.reload();
    });
  });

  // // 第三方登录初始化函数
  // function initializeThirdPartyLogin() {
  //   // Apple ID 初始化
  //   if (window.AppleID) {
  //     try {
  //       AppleID.auth.init({
  //         clientId: 'strutt.inc',
  //         scope: 'name email',
  //         redirectURI: 'https://co-designer.strutt.inc/pages/register-landing',
  //         usePopup: false
  //       });
  //     } catch (error) {
  //       console.error('Failed to initialize Apple ID:', error);
  //     }
  //   } else {
  //   }

  //   // Apple 登录成功回调 - Popup 模式
  //   window.addEventListener('AppleIDSignInOnSuccess', async function (event) {

  //     if (event.detail && event.detail.user) {
  //       // 用户数据已获取
  //     }

  //     if (event.detail && event.detail.authorization) {
  //     }

  //     try {
  //       // 使用 Apple 的 id_token 进行认证
  //       const appleAuthData = {
  //         email: event.detail.user.email || '',
  //         authUserId: event.detail.user.sub || event.detail.user.id || '',
  //         firstName: event.detail.user.name?.firstName || '',
  //         lastName: event.detail.user.name?.lastName || '',
  //         emailVerified: event.detail.user.email_verified || false,
  //         registerSource: 1,
  //         authPlatform: 2 // 苹果为2
  //       };


  //       // 调用后端注册接口 - 参考Google登录接口
  //       const baseURL = window.API_BASE_URL;
  //       const response = await fetch(`${baseURL}/authority/api/third/token`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'X-Client-Type': 'app'
  //         },
  //         body: JSON.stringify({
  //           thirdPlatform: 1, // Apple为1，Google为2
  //           idToken: event.detail.authorization?.id_token || ''
  //         })
  //       });

  //       if (!response.ok) {
  //         throw new Error(response.message);
  //       }

  //       const registerResp = await response.json();

  //       // 存储用于注册成功页自动登录
  //       sessionStorage.setItem('appleAuth', JSON.stringify({
  //         idToken: event.detail.authorization.id_token,
  //         email: event.detail.user.email,
  //         id: event.detail.user.sub || event.detail.user.id,
  //         userData: appleAuthData
  //       }));

  //       if (registerResp && registerResp.code === 200) {
  //         // 保存 accessToken / refreshToken - 参考Google登录的token保存逻辑
  //         if (registerResp.data) {
  //           if (registerResp.data.accessToken) {
  //             window.authAPI.saveAccessToken(registerResp.data.accessToken);
  //           }
  //           if (registerResp.data.refreshToken) {
  //             window.authAPI.saveRefreshToken(registerResp.data.refreshToken);
  //           }
  //           if (window.userProfileAPI && window.userProfileAPI.clearCachedUserData) {
  //             window.userProfileAPI.clearCachedUserData();
  //           }
  //         }

  //         // 检查是否从商品详情页来的
  //         const fromProductPage = sessionStorage.getItem('fromProductPage');
  //         if (fromProductPage === 'true') {
  //           // 使用Shopify直接购买链接格式：/cart/{variant_id}:{quantity}
  //           const variantId = sessionStorage.getItem('productVariantId');
  //           const quantity = parseInt(sessionStorage.getItem('productQuantity')) || 1;
  //           if (variantId) {
  //             const checkoutUrl = `/cart/${variantId}:${quantity}`;
  //             window.location.replace(checkoutUrl);
  //           } else {
  //             // 如果没有商品信息，跳转到商品页面
  //             const productPageUrl = sessionStorage.getItem('productPageUrl') || '/';
  //             window.location.replace(productPageUrl);
  //           }
  //           return;
  //         }

  //         // 三方注册成功，跳转到注册成功页面
  //         window.location.replace('/pages/register-success?source=apple');
  //       } else {
  //         // 显示后端返回的错误信息
  //         const errorMessage = registerResp.message || 'Apple registration failed, please try again.';
  //         window.showToast(errorMessage, 'error', 5000);
  //       }
  //     } catch (e) {
  //       console.error('Register Apple user failed:', e);
  //     }
  //   });

  //   // Apple 登录失败回调
  //   window.addEventListener('AppleIDSignInOnFailure', function (event) {
  //     console.error("Apple 登录失败", event);
  //   });

  //   // Google 回调解析（URL hash 带 id_token）
  //   (function handleGoogleRedirectIfAny() {
  //     try {
  //       if (window.location.hash && (window.location.hash.includes('id_token=') || window.location.hash.includes('access_token='))) {
  //         const hash = new URLSearchParams(window.location.hash.substring(1));
  //         const idToken = hash.get('id_token');
  //         const accessToken = hash.get('access_token');


  //         if (idToken || accessToken) {

  //           // 使用access_token获取Google用户信息
  //           (async function () {
  //             try {
  //               // 首先使用access_token获取Google用户信息
  //               let googleUserInfo = null;
  //               if (accessToken) {
  //                 const googleResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
  //                   method: 'GET',
  //                   headers: {
  //                     'Authorization': `Bearer ${accessToken}`
  //                   }
  //                 });

  //                 if (googleResponse.ok) {
  //                   googleUserInfo = await googleResponse.json();
  //                 } else {
  //                   console.error('Failed to fetch Google user info:', googleResponse.status);
  //                 }
  //               }

  //               // 使用获取到的真实用户信息调用后端注册接口
  //               const baseURL = window.API_BASE_URL || 'https://4e06cea9d54be19748080d58ad6f9f22.serveo.net';
  //               const response = await fetch(`${baseURL}/authority/grant_web_auth_token`, {
  //                 method: 'POST',
  //                 headers: {
  //                   'Content-Type': 'application/json'
  //                 },
  //                 body: JSON.stringify({
  //                   email: googleUserInfo?.email || '',
  //                   authUserId: googleUserInfo?.id || '',
  //                   firstName: googleUserInfo?.given_name || '',
  //                   lastName: googleUserInfo?.family_name || '',
  //                   emailVerified: googleUserInfo?.verified_email || false,
  //                   registerSource: 1,
  //                   authPlatform: 1 // 谷歌为1
  //                 })
  //               });

  //               if (!response.ok) {
  //                 throw new Error(response.message);
  //               }

  //               const registerResp = await response.json();

  //               // 存储 id_token
  //               sessionStorage.setItem('googleAuth', JSON.stringify({
  //                 idToken: idToken
  //               }));
  //               //to do 这里可能要区分一下,要是先普通注册,再三方注册,绑定逻辑,直接保存进入账户中心,应该也是200,具体根据toast来
  //               if (registerResp && registerResp.code === 200) {

  //                 // 保存token - 参考邮箱登录的token保存逻辑
  //                 if (registerResp.data) {
  //                   window.authAPI.saveAuthToken(registerResp.data);
  //                 } else {
  //                   console.warn('No token found in Google registration response');
  //                 }

  //                 // 清除用户信息缓存，确保获取最新数据
  //                 if (window.userProfileAPI) {
  //                   window.userProfileAPI.clearCachedUserData();
  //                 }
  //                 // 仅当后端返回了 messageCode 时才显示提示
  //                 if (registerResp && registerResp.messageCode != null) {
  //                   window.showToast(registerResp.message || 'Operation completed successfully.', 'normal', 3000);
  //                 }
  //                 // 检查是否从商品详情页来的
  //                 const fromProductPage = sessionStorage.getItem('fromProductPage');
  //                 if (fromProductPage === 'true') {
  //                   // 使用Shopify直接购买链接格式：/cart/{variant_id}:{quantity}
  //                   const variantId = sessionStorage.getItem('productVariantId');
  //                   const quantity = parseInt(sessionStorage.getItem('productQuantity')) || 1;
  //                   if (variantId) {
  //                     const checkoutUrl = `/cart/${variantId}:${quantity}`;
  //                     window.location.replace(checkoutUrl);
  //                   } else {
  //                     // 如果没有商品信息，跳转到商品页面
  //                     const productPageUrl = sessionStorage.getItem('productPageUrl') || '/';
  //                     window.location.replace(productPageUrl);
  //                   }
  //                   return;
  //                 }

  //                 // 三方注册成功，弹出toast并跳转到注册成功页面
  //                 window.location.replace('/pages/register-success?source=google');
  //               } else {
  //                 // 显示后端返回的错误信息
  //                 const errorMessage = registerResp.message || 'Registration failed, please try again.';
  //                 window.showToast(errorMessage, 'error', 5000);
  //               }
  //             } catch (e) {
  //               console.error('Register google user failed:', e);
  //               window.showToast('Sign up failed, please try again.', 'error', 3000);
  //             }
  //           })();
  //         }
  //       }
  //     } catch (e) {
  //       console.error('Handle Google redirect error:', e);
  //     }
  //   })();
  // }

  // // Google OAuth 登录函数 - 支持 id_token
  // function oauthSignIn() {
  //   var oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';
  //   var form = document.createElement('form');
  //   form.setAttribute('method', 'GET');
  //   form.setAttribute('action', oauth2Endpoint);
  //   var params = {
  //     'client_id': '434399780698-6rnau89v7a77ilcgd3s0r67ejh69bs7a.apps.googleusercontent.com',
  //     'redirect_uri': 'https://co-designer.strutt.inc/pages/main-register-landing',
  //     'response_type': 'token id_token',
  //     'scope': 'openid email profile',
  //     'state': 'shopify_oauth_google',
  //     'nonce': generateNonce()
  //   };
  //   for (var p in params) {
  //     var input = document.createElement('input');
  //     input.setAttribute('type', 'hidden');
  //     input.setAttribute('name', p);
  //     input.setAttribute('value', params[p]);
  //     form.appendChild(input);
  //   }
  //   document.body.appendChild(form);
  //   form.submit();
  // }

  // // 生成随机 nonce 用于 id_token 验证
  // function generateNonce() {
  //   const array = new Uint8Array(16);
  //   crypto.getRandomValues(array);
  //   return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  // }
